import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";

const Partners = () => {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    const fetchPartners = async () => {
      const querySnapshot = await getDocs(collection(db, "partners"));
      const data = querySnapshot.docs.map((doc) => doc.data());
      setPartners(data);
    };
    fetchPartners();
  }, []);

  return (
    <section style={styles.section}>
      <h2 style={styles.title}>شركاؤنا</h2>
      <div style={styles.grid}>
        {partners.map((partner, index) => (
          <div key={index} style={styles.card}>
            <img src={partner.image} alt={partner.name} style={styles.image} />
            <p style={styles.name}>{partner.name}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: "60px 20px",
    backgroundColor: "#f8faff",
    textAlign: "center",
  },
  title: {
    fontSize: "28px",
    color: "#0056b3",
    marginBottom: "30px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
    gap: "20px",
    justifyItems: "center",
  },
  card: {
    background: "#fff",
    borderRadius: "10px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
    padding: "15px",
    transition: "transform 0.3s",
  },
  image: {
    width: "100px",
    height: "100px",
    objectFit: "contain",
  },
  name: {
    marginTop: "10px",
    color: "#333",
    fontWeight: "bold",
  },
};

export default Partners;
